import type { CenterArea } from './center.ts';
import type { Player } from './player.ts';
import type { Holding } from './tile.ts';

export type GameStatus = 'WAITING' | 'IN_PROGRESS' | 'FINISHED';

/**
 * 게임 진행 통계.
 * - startedAt: startGame 호출 시각 (ms epoch). createGame 직후엔 0.
 * - finishedAt: status가 FINISHED로 전이된 시각 (ms epoch). 진행 중이면 null.
 */
export type GameMetrics = {
  startedAt: number;
  finishedAt: number | null;
};

export type GameState = {
  roomCode: string;
  players: Player[];
  center: CenterArea;
  currentPlayerIdx: number;
  bonusActive: boolean;
  status: GameStatus;
  winnerId: string | null;
  holding: Holding | null;
  metrics: GameMetrics;
  /**
   * 현재 턴 만료 시각 (ms epoch).
   * IN_PROGRESS 상태에서만 유효. WAITING/FINISHED는 null.
   * 만료 시 서버가 자동 패스 처리.
   */
  turnDeadline: number | null;
};

export const TOTAL_TILES = 100;

/**
 * 한 플레이어 턴의 제한 시간 (ms).
 * 만료 시 서버가 자동 패스 처리.
 */
export const TURN_TIME_LIMIT_MS = 30_000;
